import { CVI_TYPES } from 'constants/medical';
import axios from '../index';

export const requestPatientCreate = ({ fhirModel, smileModel }) =>
  axios.post('/oauth/registration', { fhirModel, smileModel });

export const requestPatientList = ({
  sort,
  desc,
  count,
  elements,
  pagesOffset,
  type,
  searchValue,
  generalPracitioner,
}) =>
  axios.get(`/fhir/Patient`, {
    params: {
      _total: 'accurate',
      _count: count,
      _elements: elements,
      _getpagesoffset: pagesOffset,
      [`general-practitioner`]: generalPracitioner,
      [`_sort${desc ? ':desc' : ':asc'}`]: sort,
      ...(searchValue && { [type]: searchValue }),
    },
  });

export const requestCardiovascularInvestigationsGetList = ({ patientId, userId }) =>
  Promise.all(
    CVI_TYPES.map(type =>
      axios.get(`/fhir/DocumentReference`, {
        params: {
          type,
          _count: 1,
          _sort: '_lastUpdated',
          _elements: '-content',
          subject: patientId,
          author: userId,
        },
      }),
    ),
  ).then(response => ({ data: response.map(({ data }) => data) }));

export const requestPatientsResourceById = ({ patientId }) =>
  axios.get(`/fhir/Patient/${patientId}`);

export const requestPutPatientById = resource =>
  axios.put(`/fhir/Patient/${resource.id}`, resource);

export const requestPutChangePatientsPassword = ({ patientId, password }) =>
  axios.put(`/user-management/${patientId}/password`, { password });

export const requestPatientGroupUpdate = ({ siteId }) =>
  axios.patch(`/redcap/update/site/${siteId}`);
